import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import TestimonialCard from './components/TestimonialCard';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Main Content */}
      <div className="flex flex-col lg:flex-row min-h-screen">
        {/* Left Side - Branding & Info */}
        <div className="hidden lg:flex lg:w-1/2 bg-primary relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary to-primary/80" />
          
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-20 left-20 w-32 h-32 border border-white rounded-full" />
            <div className="absolute top-40 right-32 w-24 h-24 border border-white rounded-full" />
            <div className="absolute bottom-32 left-32 w-40 h-40 border border-white rounded-full" />
          </div>
          
          <div className="relative z-10 flex flex-col justify-center px-12 py-16">
            <div className="max-w-md">
              <h1 className="text-4xl font-heading font-bold text-white mb-6">
                PenGame PR Hub
              </h1>
              <p className="text-xl text-white/90 mb-8 leading-relaxed">
                Streamline your public relations workflow with AI-powered content creation and comprehensive media management.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-3 text-white/90">
                  <div className="w-2 h-2 bg-white rounded-full" />
                  <span>AI-powered press release generation</span>
                </div>
                <div className="flex items-center space-x-3 text-white/90">
                  <div className="w-2 h-2 bg-white rounded-full" />
                  <span>Professional press kit builder</span>
                </div>
                <div className="flex items-center space-x-3 text-white/90">
                  <div className="w-2 h-2 bg-white rounded-full" />
                  <span>Comprehensive media contact management</span>
                </div>
                <div className="flex items-center space-x-3 text-white/90">
                  <div className="w-2 h-2 bg-white rounded-full" />
                  <span>Advanced analytics and reporting</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="flex-1 lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-12">
          <div className="w-full max-w-md mx-auto">
            {/* Mobile Logo */}
            <div className="lg:hidden text-center mb-8">
              <h1 className="text-2xl font-heading font-bold text-primary">
                PenGame PR Hub
              </h1>
              <p className="text-muted-foreground mt-2">
                Professional PR management platform
              </p>
            </div>

            {/* Login Form */}
            <LoginForm />

            {/* Security Badges */}
            <SecurityBadges />

            {/* Testimonial */}
            <TestimonialCard />
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-card border-t border-border py-6">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} PenGame Publishing. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-muted-foreground hover:text-foreground transition-colors duration-200">
                Support
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Login;